import axios from 'axios';

// 🔥 ИСПРАВЛЕНО: Логика выбора URL
// Если есть переменная окружения VITE_API_URL — берем её.
// Если нет, и мы на localhost — берем localhost:5000.
// Иначе — боевой сервер.
export const API_ORIGIN = 
  import.meta.env?.VITE_API_URL || 
  (window.location.hostname === 'localhost' ? 'http://localhost:5000' : 'https://lenuscrm.mn');

// Создаём инстанс
const api = axios.create({
  baseURL: API_ORIGIN,
});

// Нормализация пути: гарантированно добавляем /api префикс ко всем относительным URL
function withApiPrefix(url) {
  if (!url) return url;

  // Абсолютные URL (http/https) не трогаем
  if (/^https?:\/\//i.test(url)) return url;

  // Уже префиксованные варианты
  if (url.startsWith('/api/')) return url;
  if (url.startsWith('api/')) return `/${url}`;

  // Если начинается с "/", добавим /api перед ним
  if (url.startsWith('/')) return `/api${url}`;

  // Относительный путь без начального "/", добавим /api/
  return `/api/${url}`;
}

// Перехватчик — добавляет /api к относительным путям и подставляет токен
api.interceptors.request.use((config) => {
  const next = { ...config };

  if (next.url) {
    next.url = withApiPrefix(next.url);
  }

  try {
    const token = localStorage.getItem('token') || localStorage.getItem('accessToken') || localStorage.getItem('jwt');
    if (token) {
      next.headers = next.headers || {};
      next.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // no-op
  }

  return next;
});

export default api;